import React from "react";

import "./Footer.css";

function Footer() {

  return (
    <>
      <div className="row">
        <div className="col">
          <span className="h-separator-footer"></span>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6 col-md-12">
          
        </div>
        <div className="col-lg-6 col-md-12 small text-end">
          <p>
            Écrivez-nous à <u>bonjour@ecolezero.com</u><br/>
            <a href="https://www.instagram.com/ecole_zero/">Suivez nous sur Instagram ↗</a><br/>
            <a href="https://airtable.com/shrvwZ8V8oLMqa05J">S'abonner à la newsletter ↗</a>
          </p>
        </div>
      </div>
    </>
  )
  
}

export default Footer;